export const setYearReceiptsDaily = (receipts: any) => ({
    type: 'SET_YEAR_RECEIPTS_DAILY',
    payload: receipts
});

export const setHomeTimeInterval = (timeInterval: any) => ({
    type: 'SET_HOME_TIME_INTERVAL',
    payload: timeInterval
});

export const setHomeReceipts = (receipts: any) => ({
    type: 'SET_HOME_RECEIPTS',
    payload: receipts
});

export const addGranularSalesStats = (granularStats: any) => ({
    type: 'ADD_GRANULAR_SALES_STATS',
    payload: granularStats
});
